import React from 'react';
import { connect } from 'react-redux';
import { userSelectors } from '../redux/user';

type ChildrenFn = (props: { label: string; description: string }) => React.ReactNode;
type UserNameLabelTextProps = {
  children: ChildrenFn;
};
type Props = MapStateToProps & UserNameLabelTextProps;
export const UserNameLabelText = (props: Props) => {
  const { label, description } = props;
  return props.children({
    label,
    description
  });
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
function mapStateToProps(state: WebOrder.State) {
  return {
    ...userSelectors.getUserNameLabelText(state)
  };
}

export default connect<MapStateToProps, {}, UserNameLabelTextProps>(mapStateToProps)(
  // @ts-ignore react-redux mismatch types
  UserNameLabelText
);
